<template>
	<div class="login_page">
		<a-row>
			<a-col :span="12">
				<div class="bg">
					<h3 class="support">
						<img src="../../../static/images/login_bg.png" alt />
					</h3>
				</div>
			</a-col>
			<a-col :span="12">
				<div class="login">
					<div class="content">
						<h1>宠米后台管理系统</h1>
						<div class="input">
							<div class="input-box">
								<a-icon type="user" />
								<input placeholder="请输入账号" v-model="formData.loginName" style="width: 249px" />
							</div>
							<div class="input-box">
								<a-icon type="lock" />
								<input placeholder="请输入密码" v-model="formData.password" style="width: 249px"
									type="password" />
							</div>
							<button @click="goLogin">登 录</button>
						</div>
					</div>
				</div>
			</a-col>
		</a-row>
	</div>
</template>

<script>
	import {
		toLoginApi,

	} from "../../api/index";
	import md5 from "js-md5";
	export default {
		name: "Login",
		data() {
			return {
				buildEnv: "TEST",
				mode: "code",
				isProd: process.env.NODE_ENV === "production" ? true : false,
				formData: {
					loginName: "",
					password: "",
				},
			};
		},
		created() {
			this.buildEnv = process.env.VUE_APP_CONSTANT ?
				process.env.VUE_APP_CONSTANT :
				"TEST";
		},
		mounted() {
			// this.weiXin();
		},
		watch: {
			$route(to, from) {
				console.log(to);
			},
		},
		methods: {
			goLogin() {
				// this.$router.push("/home");
				toLoginApi({
					username: this.formData.loginName,
					password: this.formData.password,
				}).then((res) => {
					console.log(res);
					if (res.resultStatus) {
						var obj = {
							...res.resultData,
						};
						this.$store.commit("IS_LOGGE_IN", true);
						this.$store.commit("UPDATE_USER_INFO", obj);
						localStorage.setItem("fhaccessToken", res.resultData.accessToken);
						localStorage.setItem("serverTime", res.resultData.serverTime);
						localStorage.setItem("zoneId", res.resultData.zoneId);
						// this.$store.commit("ADD_LABEL", "WELCOME");
						// this.$router.push({
						// 	name: "WELCOME",
						// });
						this.$store.commit("ADD_LABEL", "VIPLIST");
						this.$router.push({
							name: "VIPLIST",
						});
					} else {
						this.$message.error(res.errorMessage);
					}
				});
			},

			changeMode() {
				if (this.mode === "code") {
					this.mode = "password";
				} else {
					//this.weiXin();
					this.mode = "code";
				}
			},
		},
	};
</script>

<style lang="less">
	.login_page {
		width: 100%;
		height: 100%;
		text-align: center;

		.ant-row {
			height: 100%;

			.ant-col-12 {
				height: 100%;

				.bg {
					width: 100%;
					height: 100%;
					background: #f6f6f6;
					overflow: hidden;
					position: relative;

					.logo {
						width: 12%;
						height: auto;
						position: relative;
						left: 0;
						right: 0;
						margin: 26% auto 0;

						img {
							width: 100%;
						}
					}

					.support {
						font-size: 18px;
						color: #fff;
						line-height: 25px;
						position: absolute;
						bottom: 24%;
						left: 0;
						right: 0;
						margin: auto;

						img {
							width: 800px;
						}
					}
				}

				.login {
					height: 100%;
					background: #f6f6f6;
					position: relative;

					.content {
						width: 432px;
						height: 640px;
						position: absolute;
						top: 0;
						left: 0;
						right: 0;
						bottom: 0;
						margin: auto;
						background: #f8f8f8;
						border: 1px solid #e1e1e1;

						.corner {
							width: 20%;
							float: right;
							cursor: pointer;
						}

						h1 {
							font-size: 24px;
							color: #2CBD9C;
							margin: 80px 0 0 0;
						}

						.QR_code {
							margin: 0 auto 38px;

							img {
								width: 100%;
							}
						}

						.tip {
							font-size: 14px;
							color: #999999;
						}

						.input {
							width: 280px;
							margin-left: 76px;
							margin-top: 80px;

							button {
								width: 280px;
								height: 50px;
								background: #2CBD9C;
								border-radius: 3px;
								border: 0;
								outline: 0;
								cursor: pointer;
								font-size: 18px;
								color: #ffffff;
								margin-top: 116px;
							}

							.input-box {
								display: flex;
								justify-content: center;
								align-items: center;
								margin-bottom: 24px;
								width: 100%;
								height: 40px;
								background-color: #f6f6f6;
								background: rgba(246, 246, 246, 1);
								border-radius: 3px;
								border: 1px solid rgba(221, 221, 221, 1);

								img {
									width: 16px;
									height: 16px;
									margin-left: 15px;
								}

								input {
									height: 100%;
									border: 0;
									background-color: #f6f6f6;
									outline: none;
									padding-left: 15px;
									color: #383333;
									font-weight: 400;
									font-size: 14px;
								}

								.input {
									border: 0 !important;
								}
							}
						}
					}
				}
			}
		}

		.point {
			cursor: pointer;
		}
	}
</style>
